import { Col, Row, Grid, Spin } from 'antd'
import React from 'react'
import styled from 'styled-components'

const SummaryItemContainer = styled(({ last, horizontal, ...props }) => <Row {...props} />)`
  padding: 30px;
  position: relative;
  box-shadow: 0px 64px 64px -48px rgba(15, 15, 15, 0.1);
  border-radius: 16px;
  display: flex;
  justify-content: ${(props) => (props.variant === 'light' ? 'flex-start' : 'center')};
  background: ${(props) =>
    props.variant === 'light' ? props.theme.colors_v2.primary_blue : 'transparent'};

  @media (max-width: 768px) {
    justify-content: flex-start;
    padding-left: 32px;
    align-items: center;
    padding: 12px;
  }
`

const DetailContainer = styled(Col)`
  text-align: left;
  display: flex;
  flex-direction: column;
  justify-content: center;
  @media (max-width: 768px) {
  }
`

const Title = styled.div`
  color: ${({ theme }) => theme.colors_v2.neutral_4};
  margin-bottom: 8px;
  font-size: 14px;
  line-height: 20px;
  @media (max-width: 768px) {
    fotn-size: 12px;
  }
`

const Value = styled.div`
  font-size: 28px;
  line-height: 32px;
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  color: ${({ theme }) => theme.colors_v2.white};
  @media (max-width: 768px) {
    font-size: 18px;
    line-height: 24px;
  }
`

const Icon = styled.div`
  width: 55px;
  height: 55px;
  align-items: center;
  display: flex;
  justify-content: center;
  margin-right: 16px;
  @media (max-width: 768px) {
    width: 32px;
    height: 32px;
  }
  img {
    width: 100%;
  }
`

export default function SummaryItem({ icon, title, value, last, status, variant }) {
  const { lg } = Grid.useBreakpoint()
  return (
    <SummaryItemContainer last={last} horizontal={lg} variant={variant}>
      <Icon>
        <img src={icon} />
      </Icon>
      <DetailContainer>
        <Title>{title}</Title>
        <Value>{status ? value : <Spin />}</Value>
      </DetailContainer>
    </SummaryItemContainer>
  )
}
